import {IconProp} from "@fortawesome/fontawesome-svg-core";

const mimeIcons: Record<string, IconProp> = {
    image: "file-image",
    audio: "file-audio",
    video: "file-video",
    "application/pdf": "file-pdf",
    "application/msword": "file-word",
    "application/vnd.ms-word": "file-word",
    "application/vnd.oasis.opendocument.text": "file-word",
    "applicativnd.openxmlformatsfficedocument.wordprocessingml": "file-word",
    "application/vnd.ms-excel": "file-excel",
    "applicativnd.openxmlformatsfficedocument.spreadsheetml": "file-excel",
    "application/vnd.oasis.opendocument.spreadsheet": "file-excel",
    "application/vnd.ms-powerpoint": "file-powerpoint",
    "applicativnd.openxmlformatsfficedocument.presentationml": "file-powerpoint",
    "application/vnd.oasis.opendocument.presentation": "file-powerpoint",
    "text/plain": "file-alt",
    "text/html": "file-code",
    "application/json": "file-code",
    "application/gzip": "file-archive",
    "application/zip": "file-archive",
};

export const getIconFromMIME = (mimeType: string | false): IconProp => {
    if (!mimeType) return "file";
    for (const key of Object.keys(mimeIcons)) {
        if (mimeType.startsWith(key)) return mimeIcons[key];
    }
    return "file";
};
